<template>
  <MetricView view-name="staff" />
</template>

<script lang="ts" setup>
import MetricView from '@/components/MetricView.vue';
</script>
